// GTM DataLayer Service
declare global {
  interface Window {
    dataLayer: {
      event: string;
    }[];
  }
}

export const pushToDataLayer = (data: Record<string, any>) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(data as any);
  }
};

export const pushEvent = (eventName: string, data?: Record<string, any>) => {
  pushToDataLayer({
    event: eventName,
    ...data,
  });
};
